$(document).ready(function() {

  $(".hamburger").click(function() {
    if ($(".main_nav_links").css("display") === "none") {
      $(this).addClass("is-active")
      .css({"position": "fixed",
            "top": "7px"});
      $(".main_nav_links").attr("id", "display");
    } else {
      $(this).removeClass("is-active")
      .css({"position": "relative",
            "top": "-15px"});
      $(".main_nav_links").removeAttr("id", "display");
    }
  });
});



// WEBPACK FOOTER //
// app/frontend/javascripts/hamburger_menu.js